import { Switch } from '@components/Switch/Switch';
import classNames from 'classnames';
import { ReactNode, useId } from 'react';
import css from './SwitchRow.module.scss';

/** A labelled toggle with an optional hint under the label; the label toggles the switch. */
export function SwitchRow({
  label,
  hint,
  checked,
  onChange,
  disabled = false,
  className,
}: {
  label: ReactNode;
  hint?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}) {
  const id = useId();
  return (
    <div className={classNames(css.row, disabled && css.disabled, className)}>
      <label htmlFor={id} className={css.text}>
        <span className={css.label}>{label}</span>
        {hint && <span className={css.hint}>{hint}</span>}
      </label>
      <Switch id={id} checked={checked} onChange={onChange} disabled={disabled} />
    </div>
  );
}
